import React, { useEffect } from "react";

const Plot = ({ data, layout, style, config, displaylogo, responsive, modeBarButtonsToRemove, containerId }) => {
  useEffect(() => {
    if (window.Plotly) {
      window.Plotly.newPlot(containerId, data, layout, config);
    }
  }, [data, layout, style, config, displaylogo, responsive, modeBarButtonsToRemove, containerId]);

  return (
    <div
      id={containerId}
      style={style}
      displaylogo={displaylogo}
      responsive={responsive}
      modeBarButtonsToRemove={modeBarButtonsToRemove}
      config={config}
    />
  );
};

export default Plot;
